import { useNavigate } from 'react-router-dom';
import type { Hizmet } from '@/mocks/hizmetler';

interface Props {
  hizmet: Hizmet;
}

export default function DetayHero({ hizmet }: Props) {
  const navigate = useNavigate();

  return (
    <div className="relative pt-[68px]">
      {/* Kapak Görseli */}
      <div className="relative h-72 md:h-[420px] overflow-hidden">
        <img
          src={hizmet.kapakGorsel}
          alt={hizmet.baslik}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(26,15,10,0.85) 0%, rgba(26,15,10,0.35) 50%, rgba(26,15,10,0.2) 100%)' }} />

        {/* Geri butonu */}
        <button
          onClick={() => navigate('/hizmetler')}
          className="absolute top-5 left-5 md:top-6 md:left-8 flex items-center gap-2 text-white/80 text-sm px-4 py-2 rounded-full hover:text-[#E8B86D] transition-all cursor-pointer border border-white/20"
          style={{ background: 'rgba(26,15,10,0.5)', backdropFilter: 'blur(8px)' }}
        >
          <i className="ri-arrow-left-line"></i>
          Tüm Hizmetler
        </button>

        {/* Başlık */}
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
          <span className="inline-block text-[#E8B86D] text-xs font-medium px-3 py-1 rounded-full mb-3 border border-[#E8B86D]/30"
            style={{ background: 'rgba(232,184,109,0.12)' }}>
            {hizmet.kategori}
          </span>
          <h1
            className="font-black italic text-white mb-2 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.8rem, 4vw, 3rem)' }}
          >
            {hizmet.baslik}
          </h1>
          <p className="text-white/55 text-sm md:text-base font-light">{hizmet.altBaslik}</p>
        </div>
      </div>

      {/* Bilgi Bandı */}
      <div className="border-b border-white/10" style={{ background: 'rgba(255,255,255,0.04)' }}>
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-4 flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-3 text-sm">
            <div className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E8B86D]/25"
              style={{ background: 'rgba(232,184,109,0.1)' }}>
              <i className="ri-time-line text-[#E8B86D]"></i>
            </div>
            <div>
              <p className="text-white/35 text-xs">Süre</p>
              <p className="font-semibold text-white text-sm">{hizmet.sure}</p>
            </div>
          </div>
          <div className="w-px h-8 bg-white/10 hidden sm:block" />
          <div className="flex items-center gap-3 text-sm">
            <div className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E8B86D]/25"
              style={{ background: 'rgba(232,184,109,0.1)' }}>
              <i className="ri-price-tag-3-line text-[#E8B86D]"></i>
            </div>
            <div>
              <p className="text-white/35 text-xs">Kampanya Fiyatı</p>
              <div className="flex items-center gap-2">
                <span className="font-black text-[#E8B86D] text-lg">{hizmet.fiyat}</span>
                <span className="text-white/25 text-xs line-through">{hizmet.eskiFiyat}</span>
              </div>
            </div>
          </div>
          <div className="w-px h-8 bg-white/10 hidden sm:block" />
          <div className="flex items-center gap-3 text-sm">
            <div className="w-9 h-9 flex items-center justify-center rounded-full border border-[#E8B86D]/25"
              style={{ background: 'rgba(232,184,109,0.1)' }}>
              <i className="ri-star-fill text-[#E8B86D]"></i>
            </div>
            <div>
              <p className="text-white/35 text-xs">Müşteri Puanı</p>
              <p className="font-semibold text-white text-sm">5.0 / 5.0</p>
            </div>
          </div>
          <div className="ml-auto">
            <a
              href="https://wa.me/905001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#1A0F0A] text-sm font-black px-5 py-2.5 rounded-full transition-all whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
            >
              <i className="ri-calendar-check-line"></i>
              Randevu Al
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
